
import React, { createContext, useContext } from "react";
import { AuthFormContextType } from "./types";

// Create context with default values
const AuthFormContext = createContext<AuthFormContextType | undefined>(undefined);

export const useAuthForm = () => {
  const context = useContext(AuthFormContext);
  if (context === undefined) {
    throw new Error("useAuthForm must be used within an AuthFormProvider");
  }
  return context;
};

export { AuthFormContext };
